var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleThumbnail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 244,
    height: 244,
    viewBox: "0 0 244 244",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_34",
    "data-name": "Ellipse 34",
    cx: 122,
    cy: 122,
    r: 122,
    transform: "translate(6464 12748)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Circle_Thumbnail",
    "data-name": "Circle Thumbnail",
    transform: "translate(-6464 -12748)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_174",
    "data-name": "Rectangle 174",
    width: 244,
    height: 244,
    transform: "translate(6464 12748)",
    fill: "#d1d4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_10",
    "data-name": "Polygon 10",
    d: "M76.5,0,153,131H0Z",
    transform: "translate(6440 12861)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_11",
    "data-name": "Polygon 11",
    d: "M107.5,0,215,184H0Z",
    transform: "translate(6517 12808)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_33",
    "data-name": "Ellipse 33",
    cx: 19,
    cy: 19,
    r: 19,
    transform: "translate(6504 12787)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleThumbnail);
export default __webpack_public_path__ + "static/media/CircleThumbnail.f9d5efcb3c1adbce2590bb3e7a92c457.svg";
export { ForwardRef as ReactComponent };